<template>
  <div class="slip-preview-modal">
    <h4 class="modal-title">{{ $t("codTransferWaiting.transfer_slip") }}</h4>

    <div class="info-grid">
      <div class="info-row">
        <span class="label">{{ $t("codTransferWaiting.shop") }}</span>
        <span class="value">{{ item.name }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ $t("codTransferWaiting.bill_count") }}</span>
        <span class="value strong">{{ formatCurrency(item.bill_count) }} {{ $t("common.ກີບ") }}</span>
      </div>
      <div class="info-row" v-if="item.transfer_date">
        <span class="label">{{ $t("codTransferWaiting.transfer_date") }}</span>
        <span class="value">{{ item.transfer_date }}</span>
      </div>
    </div>

    <div class="preview-frame">
      <img :src="item.slip_image_url" alt="bank transfer slip" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlipPreviewDialog',
  props: {
    item: { type: Object, required: true },
  },
  methods: {
    formatCurrency(v) { return (Number(v) || 0).toLocaleString('en-US'); },
  },
};
</script>

<style lang="scss" scoped>
.slip-preview-modal {
  padding: 6px 12px 10px;
  width: 100%;
}
.modal-title {
  font-weight: 600;
  font-size: 17px;
  color: #2c2f36;
  margin: 4px 0 12px;
  text-align: center;
}
.info-grid {
  background: #f5f7fb;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 14px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 13px;
}
.label { color: #8b8f99; }
.value { color: #2c2f36; }
.value.strong { font-weight: 600; }

.preview-frame {
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
  text-align: center;
  img {
    max-width: 100%;
    max-height: 60vh;
    border-radius: 4px;
  }
}
</style>
